import Immutable from 'immutable';
const LOAD = 'usage/LOAD';
const LOAD_SUCCESS = 'usage/LOAD_SUCCESS';
const LOAD_FAIL = 'usage/LOAD_FAIL';
const LOAD_USER_DETAILS = 'usage/LOAD_USER_DETAILS';
const CLOSE_ERROR_MESSAGE = 'usage/CLOSE_ERROR_MESSAGE';
const LOAD_WORK_DAYS = 'usage/LOAD_WORK_DAYS';

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  usage: null,
  userList:[],
  workDaysData:{}
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case CLOSE_ERROR_MESSAGE:
      return state
        .set('loadErr', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('usage', action.res);

    case LOAD_WORK_DAYS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('workDaysData', action.res);

    case LOAD_USER_DETAILS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('userList', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('schedule', null);

    default:
      return state;
  }
};

export const hideErrorModal = () => async (dispatch, getState, api) => {
  dispatch({ type: CLOSE_ERROR_MESSAGE, action: null });
}

export const getUsageData = (userId , role ='Dentist') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  console.log(userId);
  if(!userId){
    userId ='All';
  }
  if(role) {
    role = '/'+role;
  } else {
    role = '/All';
  }
  try {
    let res = await api.get(`/usage/getUsage/${userId}${role}`);
    dispatch({ type: LOAD_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};

export const getUserList = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`/usage/getUser`);
    dispatch({ type: LOAD_USER_DETAILS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};

export const getLastNextWorkDays = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`/usage/getLastNextWorkDays`);
    dispatch({ type: LOAD_WORK_DAYS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};

export const flushUsageData = (obj) => async (dispatch, getState, api) => {
  try {
    let res = await api.put(`/usage/flushUsageData`, {data: obj});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};

export const hideUsageReport = (obj) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD });
    try {
      let res = await api.put(`/usage/hideUsageReport`, {data: obj});
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL, error: err.message });
    }
  };
